import { AssetType } from '../models';
import { BaseDAO } from './base.dao';

export class AssetTypeDAO extends BaseDAO<AssetType> {}
